import each from 'lodash/each';

import OrdersCollection from './collection';

export const state = {
  orders: {
    all: new OrdersCollection('all'),
    breakdown: new OrdersCollection('breakdown'),
  },
  currentOrder: {},
};

export const mutations = {
  setOrders(state, { type, response }) {
    state.orders[type].orders = [...state.orders[type].orders, ...response.data._embedded.items]
    state.orders[type].initialized = true;
    state.orders[type].total = response.data.total_results;
    state.orders[type].exportUrl = response.data._links.self.download;
    state.orders[type].exportOfflineUrl = response.data._links.self.download_offline;

    if (response.data._embedded.items.length === state.orders[type].limit) {
      state.orders[type].page++;
      state.orders[type].canLoad = true;
    } else {
      state.orders[type].canLoad = false;
    }
  },

  setOrdersCampaignId(state, { type, campaignId }) {
    if (state.orders[type].campaignId !== campaignId) {
      state.orders[type].campaignId = campaignId;
      mutations.resetOrders(state, type);
    }
  },

  setOrdersRelaunchCampaignId(state, { type, campaignId }) {
    if (state.orders[type].relaunchCampaignId !== campaignId) {
      state.orders[type].relaunchCampaignId = campaignId;
      mutations.resetOrders(state, type);
    }
  },

  filterOrders(state, { type, start, end, localStart, localEnd, query }) {
    state.orders[type].startDate = start;
    state.orders[type].endDate = end;
    state.orders[type].localStartDate = localStart;
    state.orders[type].localEndDate = localEnd;
    state.orders[type].query = query;
    state.orders[type].orders = [];
    state.orders[type].page = 0;
    state.orders[type].canLoad = true;
    state.orders[type].initialized = false;
    state.orders[type].total = 0;
    state.orders[type].exportUrl = null;
  },

  sortOrders(state, { type, sortColumn }) {
    state.orders[type].sortDirection = state.orders[type].sortColumn === sortColumn && !state.orders[type].sortDirection ? 1 : 0;
    state.orders[type].sortColumn = sortColumn;
    state.orders[type].orders = [];
    state.orders[type].page = 0;
    state.orders[type].canLoad = true;
    state.orders[type].initialized = false;
    state.orders[type].total = 0;
    state.orders[type].exportUrl = null;
  },

  setCurrentOrder(state, orderData) {
    state.currentOrder = orderData;
  },

  resetOrders(state, type) {
    state.orders[type].orders = [];
    state.orders[type].page = 0;
    state.orders[type].canLoad = true;
    state.orders[type].initialized = false;
  },
};